import { styled } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, Stack, Container, Typography, Button } from '@material-ui/core';
// layouts
// components
import Page from '../components/Page';
import { RecuperarSenhaForm } from '../components/authentication/recuperarSenha';
import PublicPageLayout from '../layouts/PublicLayout';
import { useState } from 'react';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 448,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 680,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function RecuperarSenha() {
  const [mostrarForm, setMostrarForm] = useState(false);

  return (
    <PublicPageLayout
      title="Recuperação de Senha | ASSEMBLEIACOOP"
      FormComponent={
        mostrarForm ? (
          <RecuperarSenhaForm />
        ) : (
          <Stack spacing={2}>
            {/* Botão para cooperado Fencom */}
            <Button
              variant="contained"
              color="primary"
              href="https://app.fencom.coop.br/recuperarAcesso.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sou Cooperado Fencom
            </Button>

            {/* Botão para exibir o formulário */}
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setMostrarForm(true)}
            >
              Recuperar Senha AssembleiaCoop
            </Button>
          </Stack>
        )
      }
    />
  );
}
